import React from 'react';

export default function Section6() {
    return (
        <div className="--container-6" data-scroll-section>
            <div className="section6-bg"/>
        </div>
    )
}